import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M2.5 12.5V6.00922C2.5 5.68929 2.65308 5.38867 2.91183 5.20049L7.41183 1.92776C7.76248 1.67274 8.23752 1.67274 8.58817 1.92776L13.0882 5.20049C13.3469 5.38867 13.5 5.68929 13.5 6.00922V12.5C13.5 13.0523 13.0523 13.5 12.5 13.5H3.5C2.94772 13.5 2.5 13.0523 2.5 12.5Z"
            fill="#F6F6F6"
            stroke="#818181"
        />
        <path
            d="M6 9.5V13.5H10V9.5C10 8.94772 9.55228 8.5 9 8.5H7C6.44772 8.5 6 8.94772 6 9.5Z"
            fill="#FB913C"
            stroke="#C2410C"
        />
        <path
            d="M1.5 6L7.43079 1.89407C7.77324 1.65699 8.22677 1.65699 8.56921 1.89407L14.5 6"
            stroke="#B73F34"
            strokeLinecap="round"
            strokeWidth="1.5"
        />
    </svg>
);

export default Icon;
